// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--Bwv50";
export var checkmark = "checkbox-module--checkmark--mf1u8";
export var disabled = "checkbox-module--disabled--Ujwy5";
export var label = "checkbox-module--label--HD-nK";